import React, { useEffect, useRef, useState } from "react";
import EditFillIcon from "../../../Assets/Icons/EditFillIcon";
import PenIcon from "../../../Assets/Icons/PenIcon";
import DefaultImage from "../../../Assets/Images/child.png";
import { MEDIA_BASE_URL } from "../../../Config/Config";
import PageTitle from "../../../Components/Layout/UserDashLyout/PageTitle";
import { usePlayerAccount } from "../../../APIContext/PlayerAccountContext";
import "./yourplayer.css";
import ConfirmModal from "../../../Components/ConfirmModal";
import { useNavigate, useLocation } from "react-router-dom";

import { Calendar } from "primereact/calendar";

import ViewSessionHistoryPopup from "../../../Components/ViewSessionHistoryPopup/ViewSessionHistoryPopup";

const jerseySizes = [
  { label: "Small", value: "S" },
  { label: "Medium", value: "M" },
  { label: "Large", value: "L" },
  { label: "Extra Large", value: "XL" },
  { label: "Youth Small", value: "YS" },
  { label: "Youth Medium", value: "YM" },
  { label: "Youth Large", value: "YL" },
];

const YourPlayers = () => {
  const { players, fetchPlayers, editPlayer, deletePlayer } =
    usePlayerAccount();
  const navigate = useNavigate();
  const [editablePlayerId, setEditablePlayerId] = useState(null);
  const [formStates, setFormStates] = useState({});
  const [isDisabled, setIsDisabled] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [playerToDelete, setPlayerToDelete] = useState(null);

  const [showPopup, setShowPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const fileInputRefs = useRef({});

  useEffect(() => {
    fetchPlayers();
  }, [fetchPlayers]);

  useEffect(() => {
    const initialFormStates = {};
    players.forEach((player) => {
      initialFormStates[player.id] = {
        name: player.name || "",
        grade: player.grade || "",
        jersey_size: player.jersey_size || "",
        date_of_birth: player.date_of_birth || "",
        age: player.age || "",
        sports_enrolled: player.sports_enrolled || "",
        package: player.package || "",
        sessions_used: player.sessions_used || "",
        profile_picture: null,
        image_preview: player.profile_picture
          ? `${player.profile_picture}`
          : DefaultImage,
      };
    });
    setFormStates(initialFormStates);
  }, [players]);

  const handleInputChange = (id, field, value) => {
    setFormStates((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const handleImageChange = (id, e) => {
    const file = e.target.files[0];
    if (file) {
      setFormStates((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          profile_picture: file,
          image_preview: URL.createObjectURL(file),
        },
      }));
    }
  };

  const handlePenClick = (id) => {
    if (editablePlayerId === id && fileInputRefs.current[id]) {
      fileInputRefs.current[id].click();
    }
  };

  const handleEditClick = (id) => {
    setEditablePlayerId((prev) => (prev === id ? null : id));
  };

  const handleAddMou = (id) => {
    navigate("/mou-form?player_id=" + id);
  };
  const formatDate = (dateObj) => {
    if (!dateObj) return "";

    // If backend sent the value as a string → convert to Date
    const date = dateObj instanceof Date ? dateObj : new Date(dateObj);

    if (isNaN(date.getTime())) return ""; // Invalid date

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (id) => {
    setIsDisabled(true);
    const playerForm = formStates[id];

    const formData = new FormData();
    if (playerForm.name) formData.append("name", playerForm.name);
    if (playerForm.grade) formData.append("grade", playerForm.grade);
    if (playerForm.jersey_size)
      formData.append("jersey_size", playerForm.jersey_size);
    if (playerForm.age) formData.append("age", playerForm.age);
    // if (playerForm.sessions_used) formData.append("sessions_used", playerForm.sessions_used);
    if (playerForm.profile_picture instanceof File) {
      formData.append("profile_picture", playerForm.profile_picture);
    }

    if (playerForm.date_of_birth) {
      const formattedDOB = formatDate(playerForm.date_of_birth);
      formData.append("date_of_birth", formattedDOB);
    }

    const result = await editPlayer(id, formData);
    if (result.success) {
      setIsDisabled(false);
      setEditablePlayerId(null);
      setFormStates((prev) => ({
        ...prev,
        [id]: {
          ...prev[id],
          profile_picture: null,
        },
      }));
      if (fileInputRefs.current[id]) {
        fileInputRefs.current[id].value = "";
      }
      fetchPlayers();
    }
  };

  const handleDelete = async (id) => {
    try {
      await deletePlayer(id);
      fetchPlayers();
    } catch (error) {}
  };

  return (
    <>
      <PageTitle
        title="Your Players"
        description="View and manage the children linked to your account. Add new players and track their activities."
        showDescription={true}
        showButton={true}
        buttonText="Add a Player"
        buttonLink="/add-a-child"
      />

      {players.length === 0 ? (
        <p className="black-text-clip">No players found.</p>
      ) : (
        players.map((player, index) => {
          const isEditing = editablePlayerId === player.id;
          const formData = formStates[player.id] || {};

          return (
            <div className="profile-container player-container" key={player.id}>
              <div className="player-wrapper">
                <div className="player-header black-text-clip">
                  <h2>{`Player ${index + 1}`}</h2> {/* ✅ Changed */}
                  <div className="btn-con">
                    {!player.has_mou && !player.parent_details.is_self_pay && (
                      <span
                        onClick={() => handleAddMou(player.id)}
                        style={{ cursor: "pointer" }}
                        className="add-mou-span"
                      >
                        ADD MOU
                      </span>
                    )}

                    <span
                      onClick={() => handleEditClick(player.id)}
                      style={{ cursor: "pointer" }}
                    >
                      <EditFillIcon />
                    </span>
                  </div>
                </div>

                <div className="profile-ele">
                  <div className="profile-image">
                    <div
                      className="img-container"
                      onClick={() => handlePenClick(player.id)}
                    >
                      <img
                        src={formData.image_preview || DefaultImage}
                        alt="Profile"
                      />
                      {isEditing && (
                        <span className="pen-icon-overlay">
                          <PenIcon />
                        </span>
                      )}
                      <input
                        type="file"
                        accept="image/*"
                        ref={(el) => (fileInputRefs.current[player.id] = el)}
                        onChange={(e) => handleImageChange(player.id, e)}
                        style={{ display: "none" }}
                      />
                    </div>
                    <button
                      className="btn gray"
                      onClick={() => {
                        setSelectedId(player.id); // pass the ID
                        setShowPopup(true); // open popup
                      }}
                    >
                      View Player Stats
                    </button>
                  </div>

                  <div className="profile-details">
                    <form
                      className="profile-form"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <div className="form-group">
                        <label
                          className="black-text-clip"
                          htmlFor={`name-${player.id}`}
                        >
                          Player Name
                        </label>
                        <input
                          type="text"
                          id={`name-${player.id}`}
                          value={formData.name}
                          onChange={(e) =>
                            handleInputChange(player.id, "name", e.target.value)
                          }
                          readOnly={!isEditing}
                        />
                      </div>

                      <div className="form-group">
                        <label
                          className="black-text-clip"
                          htmlFor={`grade-${player.id}`}
                        >
                          Grade
                        </label>
                        <input
                          type="text"
                          id={`grade-${player.id}`}
                          value={formData.grade}
                          onChange={(e) =>
                            handleInputChange(
                              player.id,
                              "grade",
                              e.target.value,
                            )
                          }
                          readOnly={!isEditing}
                        />
                      </div>

                      <div className="form-group">
                        <label
                          className="black-text-clip"
                          htmlFor={`jersey-${player.id}`}
                        >
                          Jersey Size
                        </label>
                        <select
                          id={`jersey-${player.id}`}
                          value={formData.jersey_size}
                          onChange={(e) =>
                            handleInputChange(
                              player.id,
                              "jersey_size",
                              e.target.value,
                            )
                          }
                          disabled={!isEditing}
                          className={!isEditing ? "disabled-select" : ""}
                        >
                          <option value="">Select Jersey Size</option>
                          {jerseySizes.map((size) => (
                            <option key={size.value} value={size.value}>
                              {size.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group">
                        <label
                          className="black-text-clip"
                          htmlFor={`date_of_birth-${player.id}`}
                        >
                          Date of Birth
                        </label>

                        <Calendar
                          id={`date_of_birth-${player.id}`}
                          value={
                            formData.date_of_birth
                              ? new Date(formData.date_of_birth)
                              : null
                          }
                          onChange={(e) =>
                            handleInputChange(
                              player.id,
                              "date_of_birth",
                              e.value,
                            )
                          }
                          dateFormat="yy-mm-dd"
                          showIcon
                          disabled={!isEditing}
                          placeholder="Select Date"
                          className="calender"
                        />
                      </div>

                      {/* <div className="form-group w-full">
                        <label htmlFor={`sports-${player.id}`}>
                          Sports Enrolled
                        </label>
                        <input
                          type="text"
                          id={`sports-${player.id}`}
                          value={formData.sports_enrolled}
                          onChange={(e) =>
                            handleInputChange(
                              player.id,
                              "sports_enrolled",
                              e.target.value
                            )
                          }
                          readOnly={!isEditing}
                        />
                      </div> */}

                      <div className="form-group">
                        <label
                          className="black-text-clip"
                          htmlFor={`age-${player.id}`}
                        >
                          Age
                        </label>
                        <input
                          type="text"
                          id={`age-${player.id}`}
                          value={formData.age}
                          onChange={(e) =>
                            handleInputChange(player.id, "age", e.target.value)
                          }
                          readOnly={!isEditing}
                        />
                      </div>

                      {/* <div className="form-group">
                        <label htmlFor={`sessions-${player.id}`}>
                          Sessions Used
                        </label>
                        <input
                          type="text"
                          id={`sessions-${player.id}`}
                          value={formData.sessions_used}
                          onChange={(e) =>
                            handleInputChange(
                              player.id,
                              "sessions_used",
                              e.target.value
                            )
                          }
                          readOnly={!isEditing}
                        />
                      </div> */}

                      {isEditing && (
                        <div className="form-group mt-4 pbtns">
                          <div className="form-ftr-btns">
                            <button
                              type="button"
                              className="btn orange"
                              onClick={() => handleSubmit(player.id)}
                              disabled={isDisabled}
                              style={
                                isDisabled
                                  ? {
                                      cursor: "not-allowed",
                                      background: "#ffb04f94",
                                    }
                                  : {}
                              }
                            >
                              <span className="black-text-clip">
                                {isDisabled ? "Saving ..." : "Save Changes"}
                              </span>
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => handleEditClick(player.id)}
                            >
                              <span className="black-text-clip">
                                Cancel Editing
                              </span>
                            </button>
                          </div>
                          <div className="remove-player">
                            <button
                              type="button"
                              className="btn white"
                              onClick={() => {
                                setPlayerToDelete(player);
                                setShowDeleteModal(true);
                              }}
                            >
                              <span className="black-text-clip">
                                Remove Player
                              </span>
                            </button>
                          </div>
                        </div>
                      )}

                      <ConfirmModal
                        show={showDeleteModal}
                        message={`Are you sure you want to remove ${playerToDelete?.name}?`}
                        onClose={() => setShowDeleteModal(false)}
                        onConfirm={async () => {
                          if (playerToDelete) {
                            await handleDelete(playerToDelete.id);
                            setShowDeleteModal(false);
                            setPlayerToDelete(null);
                          }
                        }}
                      />
                    </form>
                  </div>
                </div>
              </div>

              <ViewSessionHistoryPopup
                isOpen={showPopup}
                onClose={() => setShowPopup(false)}
                title="Player Stats"
                pid={selectedId}
              />
            </div>
          );
        })
      )}
    </>
  );
};

export default YourPlayers;
